import axios from "axios";
import {API} from "../config";

const path = "/servico-acolhimento";
const subPath = "/planejamento"

class PlanejamentoSAService {
  novoPlanejamentoSA(id, planejamentoSA){
    let formData = new FormData();

    for ( let key in planejamentoSA ) {
      if(!(key.includes("anexo") && planejamentoSA[key]===null)){
        formData.append(key, planejamentoSA[key]);
      }
    }

    return axios.post(API + path + `/${id}` + subPath, formData);
  }

  getPlanejamentoSA(id){
    return axios.get(API + path + `/${id}` + subPath)
  }

  atualizarPlanejamentoSA(id, planejamentoSA){
    let formData = new FormData();

    for ( let key in planejamentoSA ) {
      if(!(key.includes("anexo") && planejamentoSA[key]===null)){
        formData.append(key, planejamentoSA[key]);
      }
    }

    return axios.put(API + path + `/${id}` + subPath, formData);
  }
}

const instancePlanejamentoSA = new PlanejamentoSAService();
export default instancePlanejamentoSA;